import React, { useState } from 'react';
import wingitDesign from '../designSystem';

export default function WingitButton({
  children,
  type = 'button',
  variant = 'primary',
  disabled = false,
  onClick,
  style = {},
}) {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  const isSecondary = variant === 'secondary';

  const baseStyle = isSecondary
    ? wingitDesign.buttons.secondary
    : wingitDesign.publicPages.primaryButton;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      style={{
        ...baseStyle,
        transition: 'transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease, background 180ms ease, border-color 180ms ease',
        opacity: disabled ? 0.65 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transform: hovered && !disabled ? (pressed ? 'translateY(0)' : 'translateY(-1px)') : 'translateY(0)',
        boxShadow:
          hovered && !disabled && !isSecondary
            ? '0 10px 28px rgba(85,199,255,0.22)'
            : 'none',
        ...style,
      }}
    >
      {children}
    </button>
  );
}